import Vue from 'vue'
import Vuex from 'vuex'

import { constantRouterMap, asyncRouterMap } from '@/routes'

import actions from './actions'
import mutations from './mutations'
import hyGetters from '@huaying/hy-vue-common/src/store/getters'
import getters from './getters'

import customer from './module/customer'
import lottery from './module/lottery'
import popoverPanel from './module/popoverPanel'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    locations: [],
    routes: constantRouterMap.concat(asyncRouterMap)
  },
  getters: Object.assign({}, getters, hyGetters),
  actions,
  mutations,
  modules: {
    customer,
    lottery,
    popoverPanel
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js